module.exports = __webpack_public_path__ + "static/media/whatpeoplesay.bb41c1c4.webp";